'use strict';

angular.module('amexReconciliationApp')
  .component('userMetaControls', {
    templateUrl: 'scripts/views/components/user-meta-controls.html',
    controller: function (UserModel, $uibModal) {
      var self = this;

      self.currentUser = function() {
        return UserModel.currentUser(); 
      };

      self.showLogout = function() {
        return !UserModel.isSuperAdmin();
      };

      self.openHelpModal = function () {
        $uibModal.open({
          template: '<help-modal close-modal-callback="$close()"></help-modal>',
          size: 'lg'
        });
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/userMetaControls.js
// module id = 504
// module chunks = 0